import contacticon from "../components/Assets/contactusicon.svg";
import agenticon from "../components/Assets/agent.svg";
import mouicon from "../components/Assets/mouicon.svg";
export const MenuItems = [
  {
    title: "Contact Us",
    path: "/contact",
    cName: "company-link",
    icon: contacticon,
  },
  {
    title: "Become an Agent",
    path: "/agent",
    cName: "company-link",
    icon: agenticon,
  },
  {
    title: "MOU Terms",
    path: "/terms",
    cName: "company-link",
    icon: mouicon,
  },
];
